import Services from '../services';

export default {
  name: 'stock_adjustment',
  mixins: [Services],
  data() {
    return {
      reasons: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Receive items',
          value: 'receive'
        },
        {
          name: 'Inventory count',
          value: 'recount'
        },
        {
          name: 'Loss',
          value: 'loss'
        },
        {
          name: 'Damage',
          value: 'damage'
        }
      ],
      reason: {
        name: 'All',
        value: ''
      },
      stock_adjustment_edit_index: -1,
      stock_adjustments: [],
      stock_adjustment: {
        items: []
      },
      stock_adjustments_page: 1,
      stock_adjustments_total: 0,
      data_loading: false
    }
  },
  methods: {
    async update_stock_adjustments() {
      this.data_loading = true
      var stock_adjustments = this.$communicator.then(this, await this.$communicator('stock_adjustments', {
        arguments: [10, this.stock_adjustments_page],
        params: {
          service: this.store._id,
          reason: this.reason.value,
          search: this.search
        }
      }))
      if (stock_adjustments) {
        for (let i = 0; i < stock_adjustments.data.length; i++) {
          stock_adjustments.data[i].reason = this.$t(stock_adjustments.data[i].reason)
          var time = new Date(stock_adjustments.data[i].date)
          stock_adjustments.data[i].date = time.getDate() + '/' + (time.getMonth() + 1) + '/' + time.getFullYear()
          time = new Date(stock_adjustments.data[i].expected_on)
          stock_adjustments.data[i].expected_on = time.getDate() + '/' + (time.getMonth() + 1) + '/' + time.getFullYear()
        }
        this.stock_adjustments = stock_adjustments.data
        this.stock_adjustments_total = stock_adjustments.page
      }
      this.data_loading = false
    }
  },
  mounted() {
    this.reasons = [
      {
        name: this.$t('all'),
        value: ''
      },
      {
        name: this.$t('receive_items'),
        value: 'receive'
      },
      {
        name: this.$t('inventory_count'),
        value: 'recount'
      },
      {
        name: this.$t('loss'),
        value: 'loss'
      },
      {
        name: this.$t('damage'),
        value: 'damage'
      }
    ]
    this.reason = {
      name: this.$t('all'),
      value: ''
    }
    this.update_stock_adjustments()
  }
}